document.addEventListener(
"DOMContentLoaded",
()=>{


const button =
document.querySelector(
".floating-back-to-top"
);


if(!button) return;


window.addEventListener(
"scroll",
()=>{

if(window.scrollY > 500){

button.classList.add("active");

}else{

button.classList.remove("active");

}

});


button.addEventListener(
"click",
()=>{

window.scrollTo({

top:0,

behavior:"smooth"

});

});


});